import { lazyLogFeedback, SubstrateSearchScenario } from 'owa-search-service';

export default function sendFeedbackSignal(
    scenario: SubstrateSearchScenario,
    yesSelected: boolean,
    suggestionSetTraceId: string,
    feedbackString: string
) {
    lazyLogFeedback.importAndExecute(
        new Date(),
        suggestionSetTraceId,
        yesSelected,
        feedbackString,
        scenario
    );
}
